class NavimowCountdownTimer extends HTMLElement {
  constructor() {
    super();

    if (typeof Motion !== 'undefined' && Motion.inView) {
      Motion.inView(this, this.init.bind(this), {
        margin: "200px 0px 200px 0px",
      });
    } else {
      this.init();
    }
    this.now = parseInt(this.getAttribute("data-now")) || Date.now();
  }

  get date() {
    if (this._date) return this._date;

    const ts = this.getAttribute("data-target-ts");
    if (ts) return this._date = ts;

    const month = this.getAttribute("data-month");
    const day = this.getAttribute("data-day");
    const year = this.getAttribute("data-year");
    const hour = this.getAttribute("data-hour");
    const minute = this.getAttribute("data-minute");

    if (!month || !day || !year) {
       return new Date();
    }

    return (this._date =
      new Date(
        `${month}/${day}/${year} ${hour}:${minute}:00`,
      ));
  }

  get isCompact() {
    return (
      this.getAttribute("data-compact") === "true" ||
      (this.getAttribute("data-compact") === "mobile" && theme.config && theme.config.mqlSmall)
    );
  }

  init() {
    this.calculate();
    this.timerInterval = setInterval(this.calculate.bind(this), 1000);
  }

  formatNumber(num) {
    return num < 10 ? `0${num}` : num;
  }

  calculate() {
    const timeDifference = this.date - this.now;
    this.now += 1000;
    if (timeDifference < 0) {
      this.complete();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor((timeDifference / secondsInADay) * 1);
    const hours = Math.floor(
      ((timeDifference % secondsInADay) / secondsInAHour) * 1,
    );
    const mins = Math.floor(
      (((timeDifference % secondsInADay) % secondsInAHour) / (60 * 1000)) * 1,
    );
    const secs = Math.floor(
      ((((timeDifference % secondsInADay) % secondsInAHour) % (60 * 1000)) /
        1000) *
        1,
    );

    const fDays = this.formatNumber(days);
    const fHours = this.formatNumber(hours);
    const fMins = this.formatNumber(mins);
    const fSecs = this.formatNumber(secs);

    if (this.isCompact) {
      const dayHTML =
        days > 0
          ? `<div class="countdown__item"><p>${fDays}${theme.dateStrings.d}</p></div>`
          : "";
      const hourHTML = `<div class="countdown__item"><p>${fHours}${theme.dateStrings.h}</p></div>`;
      const minHTML = `<div class="countdown__item"><p>${fMins}${theme.dateStrings.m}</p></div>`;
      const secHTML = `<div class="countdown__item"><p>${fSecs}${theme.dateStrings.s}</p></div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    } else {
      const dayHTML =`<div class="countdown__item"><p>${fDays}</p><span class="normal-case" style="text-transform: none;">${
              days === 1 ? theme.dateStrings.day : theme.dateStrings.days
            }</span></div>`
      const hourHTML = `<div class="countdown__item"><p>${fHours}</p><span class="normal-case" style="text-transform: none;">${
        hours === 1 ? theme.dateStrings.hour : theme.dateStrings.hours
      }</span></div>`;
      const minHTML = `<div class="countdown__item"><p>${fMins}</p><span class="normal-case" style="text-transform: none;">${
        mins === 1 ? theme.dateStrings.minute : theme.dateStrings.minutes
      }</span></div>`;
      const secHTML = `<div class="countdown__item"><p>${fSecs}</p><span class="normal-case" style="text-transform: none;">${
        secs === 1 ? theme.dateStrings.second : theme.dateStrings.seconds
      }</span></div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  complete() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.hidden = true;

    // Find the container section
    const container = this.closest('.content-box');
    if (container) {
      // Hide start elements
      const startHeadings = container.querySelectorAll('.js-heading-start');
      const startDescriptions = container.querySelectorAll('.js-description-start');
      
      startHeadings.forEach(el => el.style.display = 'none');
      startDescriptions.forEach(el => el.style.display = 'none');

      // Show end elements
      const endHeadings = container.querySelectorAll('.js-heading-end');
      const endDescriptions = container.querySelectorAll('.js-description-end');

      endHeadings.forEach(el => el.style.display = 'block');
      endDescriptions.forEach(el => el.style.display = 'block');
    }
  }
}
customElements.define("navimow-countdown-timer", NavimowCountdownTimer);
